"use strict";

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ripemd160_min_1 = require("ripemd160-min");

var cryptoUtils_1 = require("./cryptoUtils");

var Ripemd160PolyfillDigest =
/*#__PURE__*/
function () {
  function Ripemd160PolyfillDigest() {
    _classCallCheck(this, Ripemd160PolyfillDigest);
  }

  _createClass(Ripemd160PolyfillDigest, [{
    key: "digest",
    value: function digest(data) {
      var instance = new ripemd160_min_1.default();
      instance.update(data);
      var hash = instance.digest();

      if (Array.isArray(hash)) {
        return Buffer.from(hash);
      } else {
        return Buffer.from(hash.buffer);
      }
    }
  }]);

  return Ripemd160PolyfillDigest;
}();

exports.Ripemd160PolyfillDigest = Ripemd160PolyfillDigest;

var NodeCryptoRipemd160Digest =
/*#__PURE__*/
function () {
  function NodeCryptoRipemd160Digest(nodeCryptoCreateHash) {
    _classCallCheck(this, NodeCryptoRipemd160Digest);

    this.nodeCryptoCreateHash = nodeCryptoCreateHash;
  }

  _createClass(NodeCryptoRipemd160Digest, [{
    key: "digest",
    value: function digest(data) {
      try {
        return this.nodeCryptoCreateHash('rmd160').update(data).digest();
      } catch (error) {
        try {
          return this.nodeCryptoCreateHash('ripemd160').update(data).digest();
        } catch (_err) {
          console.log(error);
          console.log('Node.js `crypto.createHash` exists but failing to digest for ripemd160, falling back to js implementation');
          var polyfill = new Ripemd160PolyfillDigest();
          return polyfill.digest(data);
        }
      }
    }
  }]);

  return NodeCryptoRipemd160Digest;
}();

exports.NodeCryptoRipemd160Digest = NodeCryptoRipemd160Digest;

function createHashRipemd160() {
  var nodeCryptoCreateHash = cryptoUtils_1.isNodeCryptoAvailable(function (nodeCrypto) {
    if (typeof nodeCrypto.createHash === 'function') {
      return nodeCrypto.createHash;
    }

    return false;
  });

  if (nodeCryptoCreateHash) {
    return new NodeCryptoRipemd160Digest(nodeCryptoCreateHash);
  } else {
    return new Ripemd160PolyfillDigest();
  }
}

exports.createHashRipemd160 = createHashRipemd160;

function hashRipemd160(data) {
  var hash = createHashRipemd160();
  return hash.digest(data);
}

exports.hashRipemd160 = hashRipemd160;